import { render, staticRenderFns } from "./announcementsList.vue?vue&type=template&id=0c833792&scoped=true"
import script from "./announcementsList.vue?vue&type=script&lang=js"
export * from "./announcementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c833792",
  null
  
)

export default component.exports